import React from 'react';
// import FileDownloadIcon from '@mui/icons-material/FileDownload';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';

export const getProfileMenuConfig = ({
  t,
  // onExportReport,
  onAccountSettings,
  onLogout,
  // isExportDisabled,
  isLogoutDisabled,
}) => [
  // TODO: Export report is temporarily hidden (EAC-576)
  // ...(!isExportDisabled
  //   ? [
  //       {
  //         key: 'export-report',
  //         label: t('Export report'),
  //         icon: <FileDownloadIcon fontSize="small" />,
  //         onClick: onExportReport,
  //       },
  //     ]
  //   : []),
  {
    key: 'account-settings',
    label: t('Account settings'),
    icon: <SettingsIcon fontSize="small" />,
    onClick: onAccountSettings,
  },
  {
    key: 'logout',
    label: t('Log out'),
    icon: <LogoutIcon fontSize="small" />,
    onClick: onLogout,
    disabled: isLogoutDisabled,
  },
];
